import { getUserResponse } from './answer-helpers';
import { MEMORY_KEEPER_CHAPTERS_BY_ARCHETYPE } from '../../lib/shared/memory-keeper-chapters';

const GENRE_QUESTION_WEIGHTS = {
    9104: 1,
    9105: 1,
    9106: 1.5
};

const BOOK_ARCHETYPES = ['adventure', 'loveStory', 'successStory', 'familySaga', 'comedy', 'mystery'];

const ARCHETYPE_CONTENT = {
    adventure: {
        heroine: 'The Wanderer',
        chaptersFor: 'a Wanderer',
        genre: 'Adventure',
        icon: 'compass',
        comment: 'Of course it’s an adventure. Who else packs that light?',
        chapters: ['The First Trip Without Permission', 'Places I Got Lost on Purpose', 'Strangers Who Saved Me', 'Worst Night, Best Story', 'Things I Left Behind', 'Where I Felt Most Alive', 'The Next Destination']
    },
    loveStory: {
        heroine: 'The Heartbreaker',
        chaptersFor: 'a Heartbreaker',
        genre: 'Love Story',
        icon: 'heart-with-arrow',
        comment: 'A love story. Obviously. Only you could make it this good.',
        chapters: ['The First Kiss (and the Better Second One)', 'The Summer We Don’t Talk About', 'The Ones I Almost Married', 'The Letter I Never Sent', 'Dancing Until the Lights Came On', 'What I’d Tell My Younger Self', 'The Love That Stayed']
    },
    successStory: {
        heroine: 'The High-Value Woman',
        chaptersFor: 'a High-Value Woman',
        genre: 'Success Story',
        icon: 'high-heeled-shoe',
        comment: 'A success story, and you made it look easy. (It wasn’t.)',
        chapters: ['The First Thing I Bought With My Own Money', 'Rooms I Walked Into Like I Owned Them', 'The Red Dress Years', 'People Who Underestimated Me (A Short List)', 'Expensive Mistakes, Worth Every Cent', 'Where My Taste Came From', 'Volume Two Starts Now']
    },
    familySaga: {
        heroine: 'The Matriarch',
        chaptersFor: 'a Matriarch',
        genre: 'Family Saga',
        icon: 'house-with-garden',
        comment: 'A family saga. Everyone’s in it, and you’re holding the pen.',
        chapters: ['The House Where It Started', 'Grandmother’s Rules', 'Weddings (and One Disaster)', 'Recipes Nobody Wrote Down', 'The Feud', 'Children, Mine and Borrowed', 'What I Want Them to Know']
    },
    comedy: {
        heroine: 'The Glorious Hot Mess',
        chaptersFor: 'a Glorious Hot Mess',
        genre: 'Comedy',
        icon: 'hand-over-mouth',
        comment: 'A comedy. Only you could turn that into a story people beg to hear.',
        chapters: ['The Haircut Incident', 'Jobs I Was Not Qualified For', 'My Mother Was Right (Don’t Tell Her)', 'Disasters, Ranked', 'The Wedding Speech', 'Pets, Plants and Other Responsibilities', 'Somehow It All Worked Out']
    },
    mystery: {
        heroine: 'The Femme Fatale',
        chaptersFor: 'a Femme Fatale',
        genre: 'Mystery',
        icon: 'sunglasses',
        comment: 'A mystery. Nobody has the full story. Yet.',
        chapters: ['The Night I Packed One Bag', 'Secrets I Kept for Other People', 'The Phone Call', 'Everyone Has a Version. This Is Mine.', 'The Decision Nobody Understood', 'Clues I Missed', 'The Reveal']
    }
};

function getBookArchetype(userResponses) {
    const scores = {};

    userResponses.forEach(({ questionId, id }) => {
        if (GENRE_QUESTION_WEIGHTS[questionId]) {
            scores[id] = (scores[id] || 0) + GENRE_QUESTION_WEIGHTS[questionId];
        }
    });

    const topAnswerId = Object.keys(scores).reduce((topId, answerId) => (scores[answerId] > (scores[topId] || 0) ? answerId : topId), 1);

    return BOOK_ARCHETYPES[topAnswerId - 1];
}

function getLevelIndex(userResponses, questionIds) {
    const sum = questionIds.reduce((total, questionId) => total + (getUserResponse(userResponses, questionId)?.id || 1), 0);

    if (sum <= 5) return 0;
    if (sum <= 7) return 1;
    if (sum <= 9) return 2;

    return 3;
}

function getThicknessIndex(userResponses) {
    return getLevelIndex(userResponses, [9100, 9101, 9102]);
}

function getHeatIndex(userResponses) {
    return getLevelIndex(userResponses, [9108, 9109, 9110]);
}

function getMemoryKeeperPersonalization(userResponses) {
    const archetype = getBookArchetype(userResponses);
    const chapters = MEMORY_KEEPER_CHAPTERS_BY_ARCHETYPE[archetype];

    return {
        chapters,
        initialChapter: chapters[0],
        imaginedBook: {
            author: getUserResponse(userResponses, 9114)?.text,
            archetype,
            title: getUserResponse(userResponses, 9111)?.text,
            dedication: getUserResponse(userResponses, 9112)?.text,
            thickness: getThicknessIndex(userResponses) + 1,
            heat: getHeatIndex(userResponses) + 1
        }
    };
}

export {
    BOOK_ARCHETYPES,
    ARCHETYPE_CONTENT,
    getBookArchetype,
    getThicknessIndex,
    getHeatIndex,
    getMemoryKeeperPersonalization
};
